export const TRACKER_TRIAL_EXPIRY_BANNER_OPEN = '[Trial Expiry Reminder] banner open';
export const TRACKER_TRIAL_EXPIRY_BANNER_CLOSE = '[Trial Expiry Reminder] banner close';
export const TRACKER_TRIAL_EXPIRY_BANNER_CLOSE_CLICK = '[Trial Expiry Reminder] banner close click';
export const TRACKER_TRIAL_EXPIRY_SETUP_BILLING_CLICK = '[Trial Expiry Reminder] setup billing click';
export const TRACKER_TRIAL_EXPIRY_BANNER_SUPPORT_CLICK = '[Trial Expiry Reminder] support click';
